import classNames from "classnames/bind";
import Button from "common/blocks/Button";
import { featuresSpecsModal } from "features/vehicleDetails/modals";
import { FeaturesSpecsSelectedTab } from "features/vehicleDetails/modals/FeaturesSpecs";
import { EventNames, usePub } from "hooks/usePublishSubscribe";

import styles from "./CarFeatures.module.scss";

const cx = classNames.bind(styles);

export type CarFeaturesProps = {
    featuresData: { key: string; value: string }[];
    extraFeaturesData?: { key: string; value: string }[];
    maxFeaturesSummary?: number;
    title: string;
    buttonText: string;
    buttonPostFix: string;
};

const CarFeatures = ({
    maxFeaturesSummary = 16,
    extraFeaturesData,
    featuresData,
    title,
    buttonPostFix,
    buttonText,
    handleOpenFeaturesSpecsModal,
}: CarFeaturesProps & {
    handleOpenFeaturesSpecsModal: (
        selectedRow?: string,
        selectedTab?: FeaturesSpecsSelectedTab
    ) => any;
}) => {
    const publish = usePub();

    const createRow = (key: string, value: string) => (
        <span key={key} className={cx("value")}>
            {value}
        </span>
    );

    const combinedData = [...featuresData, ...(!!extraFeaturesData ? extraFeaturesData : [])];

    let featuresComponents = combinedData?.map(({ key, value }) => createRow(key, value)) ?? [];
    const greaterThanSummaryMax = featuresComponents.length > maxFeaturesSummary;

    const show = greaterThanSummaryMax
        ? featuresComponents.slice(0, maxFeaturesSummary - 2)
        : featuresComponents;
    const remaining = greaterThanSummaryMax ? featuresComponents.slice(maxFeaturesSummary - 2) : [];

    const featuresSpecsData = handleOpenFeaturesSpecsModal("Summary", "features");

    return (
        <>
            <div className={cx("titleRow")}>
                <h4 className={cx("title")}>{title}</h4>
                {
                    <Button
                        onClick={() =>
                            publish(EventNames.OpenSidebar, {
                                sidebar: featuresSpecsModal,
                                params: featuresSpecsData,
                            })
                        }
                        theme="textLink"
                        ariaLabel={buttonText}
                    >
                        {buttonText}
                    </Button>
                }
            </div>
            <div className={cx("carFeatures")}>
                {show}
                {!!remaining.length && (
                    <Button
                        onClick={() =>
                            publish(EventNames.OpenSidebar, {
                                sidebar: featuresSpecsModal,
                                params: featuresSpecsData,
                            })
                        }
                        theme="textLink"
                        ariaLabel={`+${remaining.length} ${buttonPostFix}`}
                    >
                        +{remaining.length}
                        {buttonPostFix}
                    </Button>
                )}
            </div>
        </>
    );
};

export default CarFeatures;
